import styled, { css } from 'styled-components';
import { theme } from 'fpay-ui';

const LayoutZ = styled.div(
  ({ theme }) => css`
    display: flex;
    background-color: ${(props) => props.bgcolor || `${theme.colors.gray200}`};
    margin: 0;
  `
);
const fontTypes = {
  title: css`
    ${({ theme }) => theme.textTypes['Body-2-w400']};
    line-height: 19px;
    color: ${theme.colors.gray800};
  `,
  text: css`
    ${({ theme }) => theme.textTypes['Body-2-w400']};
    line-height: 17px;
    color: ${theme.colors.gray700};
  `,
};

const getFontTypes = ({ type }) => (fontTypes[type] ? fontTypes[type] : fontTypes.text);

const NewTable = styled.div(
  ({ theme }) => css`
    background-color: ${theme.colors.gray200};
    width: 100%;
    justify-content: space-between;
    // Here Change format to Table
    ${theme.breakpoint('md')} {
      display: flex 0 0 auto;
      flex-direction: column;
      background-color: ${theme.colors.gray200};
    }
  `
);
const RowZ = styled.div(
  ({ theme }) => css`
    display: ${(props) => (props.header ? 'none' : 'flex')};
    flex-wrap: wrap;
    text-overflow: ellipsis;
    opacity: 1;
    border-radius: 6px;
    background-color: #fff;
    padding: 12px 16px 8px;
    margin-bottom: 8px;
    justify-content: space-between;
    cursor: pointer;   
    ${theme.breakpoint('md')} {
      padding: 16px 24px 12px;
    }
    // Here Change format to Table
    ${theme.breakpoint('md')} {
      display: flex;
      flex-direction: row;
      text-overflow: ellipsis;
      background-color: ${(props) => (props.header ? `${theme.colors.gray200}` : '#ffffff')};
      border-radius: 6px;
      padding: 0 24px;
      height: 48px;
      justify-content: space-between;
      flex-wrap: wrap;
      align-content: center;
      margin-bottom: ${(props) => (props.header ? '0px' : '8px')};
    }
    ${theme.breakpoint('ll')} {
      margin-bottom: ${(props) => (props.header ? '0px' : '8px')};
    }
  `
);

const ColZ = styled.div(
  ({ theme }) => css`
    display: ${(props) => (props.nodata ? 'none' : 'block')};
    width: 50%;
    max-width: ${(props) => (props.maxwidth ? '100px' : 'none')};
    min-width: ${(props) => (props.minwidth ? '108px' : 'none')};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin-bottom: 8px;
    ${getFontTypes};
    text-align: ${(props) => props.textalign || 'left'};
    order: 0;
    // Here Change format to Table
    ${theme.breakpoint('md')} {
      display: block;
      min-width: ${(props) => (props.minwidth ? '250px' : 'none')};
      padding-top: 3px;
      height: 20px;
      margin-bottom: 0px;
      text-overflow: ellipsis;
      width: auto;
      margin-right: 10px;
      overflow: hidden;
      flex: ${(props) => (props.flex ? '1' : '1')};
      color: ${(props) =>
        props.header || props.date ? `${theme.colors.gray700}` : `${theme.colors.gray800}`};
      font-family: Roboto;
      font-weight: ${(props) => (props.header ? '500' : 'normal')};
      font-stretch: normal;
      font-style: normal;
      letter-spacing: ${(props) => (props.header ? '0.16px' : 'normal')};
      text-align: ${(props) => props.align || 'left'};
      font-size: ${(props) => (props.header ? '10px' : '14px')};
      line-height: ${(props) => (props.header ? '14px' : '19px')};
      order: ${(props) => props.order || '0'};
      ${theme.breakpoint('ll')} {
        font-size: ${(props) => (props.header ? '10px' : '14px')};
        line-height: ${(props) => (props.header ? '13px' : '14px')};
        flex: ${(props) => (props.flex ? '2' : '1')};
      }
    }
  `
);

export { NewTable };
export { RowZ, ColZ, LayoutZ };
